// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// export default function RetailDetails() {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [filter, setFilter] = useState("all");
//   const [searchNumber, setSearchNumber] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10;

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   useEffect(() => {
//     applyFilters();
//   }, [orders, filter, searchNumber]);

//   const fetchOrders = () => {
//     axios
//       .get("http://localhost/murugan/retail/retail_get.php")
//       .then((res) => {
//         setOrders(res.data);
//       })
//       .catch((err) => {
//         console.error("Error fetching retail orders:", err);
//       });
//   };

//   // Apply date + phone filter// helper to format date as YYYY-MM-DD
//   const formatDate = (date) => {
//     return date.toISOString().split("T")[0];
//   };

//   const applyFilters = () => {
//     let filtered = [...orders];
//     const today = new Date();
//     const todayStr = formatDate(today);

//     if (filter !== "all") {
//       let fromDate = new Date();

//       if (filter === "today") {
//         filtered = filtered.filter((order) => {
//           const d = new Date(order.order_date);
//           return formatDate(d) === todayStr;
//         });
//       } else if (filter === "yesterday") {
//         fromDate.setDate(today.getDate() - 1);
//         const yesterStr = formatDate(fromDate);
//         filtered = filtered.filter((order) => {
//           const d = new Date(order.order_date);
//           return formatDate(d) === yesterStr;
//         });
//       } else if (filter === "lastweek") {
//         fromDate.setDate(today.getDate() - 7);
//         filtered = filtered.filter((order) => {
//           const d = new Date(order.order_date);
//           return d >= fromDate && d <= today;
//         });
//       } else if (filter === "lastmonth") {
//         fromDate.setMonth(today.getMonth() - 1);
//         filtered = filtered.filter((order) => {
//           const d = new Date(order.order_date);
//           return d >= fromDate && d <= today;
//         });
//       }
//     }

//     if (searchNumber) {
//       filtered = filtered.filter((order) =>
//         order.customer_mobile.includes(searchNumber)
//       );
//     }

//     setFilteredOrders(filtered);
//     setCurrentPage(1);
//   };

//   // Total
//   const calculateTotal = () =>
//     filteredOrders.reduce((sum, order) => sum + parseFloat(order.total), 0);

//   const downloadPDF = () => {
//     if (filteredOrders.length === 0) {
//       Swal.fire("No Data", "No orders to download", "info");
//       return;
//     }

//     const doc = new jsPDF();
//     doc.setFontSize(16);
//     doc.text("Retail Orders Report", 14, 15);

//     const tableData = [];

//     filteredOrders.forEach((order) => {
//       order.cart.forEach((item, itemIndex) => {
//         tableData.push([
//           itemIndex === 0 ? order.invoice_no : "",
//           itemIndex === 0 ? order.customer_name : "",
//           itemIndex === 0 ? order.customer_mobile : "",
//           itemIndex === 0 ? order.order_date : "",
//           itemIndex === 0 ? order.billername : "",
//           item.product_name,
//           item.quantity,
//           parseFloat(item.price).toFixed(2),
//           (item.quantity * item.price).toFixed(2),
//           itemIndex === 0 ? parseFloat(order.total).toFixed(2) : "",
//         ]);
//       });
//     });

//     autoTable(doc, {
//       head: [
//         [
//           "Invoice",
//           "Customer",
//           "Mobile",
//           "Date",
//           "Biller",
//           "Product",
//           "Qty",
//           "Price",
//           "Subtotal",
//           "Order Total",
//         ],
//       ],
//       body: tableData,
//       startY: 25,
//       styles: { lineWidth: 0.2, lineColor: [0, 0, 0] },
//       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//     });

//     const totalAmount = calculateTotal().toFixed(2);
//     const pageWidth = doc.internal.pageSize.getWidth();

//     const totalText = `Total : Rs. ${totalAmount}`;
//     const textWidth = doc.getTextWidth(totalText);
//     const x = pageWidth - textWidth - 14;

//     doc.setFontSize(12);
//     doc.text(totalText, x, doc.lastAutoTable.finalY + 10);

//     doc.save("retail_orders.pdf");
//   };

//   // Pagination
//   const indexOfLast = currentPage * rowsPerPage;
//   const indexOfFirst = indexOfLast - rowsPerPage;
//   const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);

//   return (
//     <div className="container mt-4">
//       {/* Filters */}
//       <div className="d-flex mb-3 gap-2">
//         <select
//           value={filter}
//           onChange={(e) => setFilter(e.target.value)}
//           className="form-select form-select-sm"
//           style={{ maxWidth: "150px" }}
//         >
//           <option value="all">All</option>
//           <option value="today">Today</option>
//           <option value="yesterday">Yesterday</option>
//           <option value="lastweek">Last Week</option>
//           <option value="lastmonth">Last Month</option>
//         </select>

//         <input
//           type="text"
//           placeholder="Search Mobile"
//           value={searchNumber}
//           onChange={(e) => setSearchNumber(e.target.value)}
//           className="form-control form-control-sm"
//           style={{ maxWidth: "200px" }}
//         />

//         <button className="btn btn-sm btn-primary" onClick={downloadPDF}>
//           Download PDF
//         </button>
//       </div>

//       {/* Total */}
//       <h6 className="text-end">
//         Total: <b>₹{calculateTotal().toFixed(2)}</b>
//       </h6>

//       {/* Table */}
//       <div className="table-responsive" style={{ maxHeight: "70vh" }}>
//         <table className="table table-bordered table-sm">
//           <thead className="table-dark">
//             <tr>
//               <th>S.NO</th>
//               <th>Invoice no</th>
//               <th>Customer Name</th>
//               <th>Biller Name</th>
//               <th>Mobile</th>
//               <th>Date</th>
//               <th>Item</th>
//               <th>Qty</th>
//               <th>Price</th>
//               <th>Subtotal</th>
//               <th>Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentOrders.length > 0 ? (
//               currentOrders.map((order, orderIndex) =>
//                 order.cart.map((item, itemIndex) => (
//                   <tr key={`${orderIndex}-${itemIndex}`}>
//                     {itemIndex === 0 && (
//                       <>
//                         <td rowSpan={order.cart.length}>
//                           {indexOfFirst + orderIndex + 1}
//                         </td>
//                         <td rowSpan={order.cart.length}>{order.invoice_no}</td>
//                         <td rowSpan={order.cart.length}>
//                           {order.customer_name}
//                         </td>
//                         <td rowSpan={order.cart.length}>{order.billername}</td>
//                         <td rowSpan={order.cart.length}>
//                           {order.customer_mobile}
//                         </td>
//                         <td rowSpan={order.cart.length}>{order.order_date}</td>
//                       </>
//                     )}
//                     <td>{item.product_name}</td>
//                     <td>{item.quantity}</td>
//                     <td>₹{parseFloat(item.price).toFixed(2)}</td>
//                     <td>
//                       ₹{(item.quantity * parseFloat(item.price)).toFixed(2)}
//                     </td>
//                     {itemIndex === 0 && (
//                       <td rowSpan={order.cart.length}>
//                         ₹{parseFloat(order.total).toFixed(2)}
//                       </td>
//                     )}
//                   </tr>
//                 ))
//               )
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">
//                   No records found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="d-flex justify-content-center mt-3">
//           <button
//             className="btn btn-sm btn-secondary mx-1"
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage(currentPage - 1)}
//           >
//             Prev
//           </button>
//           <span className="align-self-center small">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             className="btn btn-sm btn-secondary mx-1"
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage(currentPage + 1)}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Api } from "../Api/Api";

export default function RetailDetails() {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState(""); // now handles invoice + mobile
  const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [orders, filter, searchTerm, selectedDate]);

  const fetchOrders = () => {
    axios
      .get(`${Api}retail/retail_get.php`)
      .then((res) => {
        setOrders(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.error("Error fetching retail orders:", err);
      });
  };

  // Format YYYY-MM-DD
  const formatDate = (date) => date.toISOString().split("T")[0];

  // Display DD-MM-YYYY
  const displayDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  const applyFilters = () => {
    let filtered = [...orders];
    const today = new Date();
    const todayStr = formatDate(today);

    if (filter !== "all") {
      let fromDate = new Date();

      if (filter === "today") {
        filtered = filtered.filter((order) => {
          const d = new Date(order.order_date);
          return formatDate(d) === todayStr;
        });
      } else if (filter === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        const yesterStr = formatDate(fromDate);
        filtered = filtered.filter((order) => {
          const d = new Date(order.order_date);
          return formatDate(d) === yesterStr;
        });
      } else if (filter === "lastweek") {
        fromDate.setDate(today.getDate() - 7);
        filtered = filtered.filter((order) => {
          const d = new Date(order.order_date);
          return d >= fromDate && d <= today;
        });
      } else if (filter === "lastmonth") {
        fromDate.setMonth(today.getMonth() - 1);
        filtered = filtered.filter((order) => {
          const d = new Date(order.order_date);
          return d >= fromDate && d <= today;
        });
      }
    }

    // Date filter
    if (selectedDate) {
      filtered = filtered.filter((order) => {
        const d = new Date(order.order_date);
        return formatDate(d) === selectedDate;
      });
    }

    // Invoice OR Mobile search
    if (searchTerm) {
      filtered = filtered.filter(
        (order) =>
          order.customer_mobile.includes(searchTerm) ||
          order.invoice_no.includes(searchTerm)
      );
    }

    setFilteredOrders(filtered);
    setCurrentPage(1);
  };

  // Total
  const calculateTotal = () =>
    filteredOrders.reduce(
      (sum, order) => sum + parseFloat(order.paid_amount),
      0
    );

  // const downloadPDF = () => {
  //   if (filteredOrders.length === 0) {
  //     Swal.fire("No Data", "No orders to download", "info");
  //     return;
  //   }

  //   const doc = new jsPDF();
  //   doc.setFontSize(16);
  //   doc.text("Retail Orders Report", 14, 15);

  //   // Determine report filter info & dynamic filename
  //   let filterInfo = "";
  //   let fileName = "retail_orders";

  //  const todayStr = formatDate(new Date());

  //   if (filter === "today") {
  //     filterInfo = `Report for Today (${displayDate(todayStr)})`;
  //     fileName += `_${todayStr}`;
  //   } else if (filter === "yesterday") {
  //     const y = new Date();
  //     y.setDate(y.getDate() - 1);
  //     filterInfo = `Report for Yesterday (${displayDate(formatDate(y))})`;
  //     fileName += `_${formatDate(y)}`;
  //   } else if (filter === "lastweek") {
  //     filterInfo = "Report for Last Week";
  //     fileName += `_lastweek`;
  //   } else if (filter === "lastmonth") {
  //     filterInfo = "Report for Last Month";
  //     fileName += `_lastmonth`;
  //   } else if (selectedDate) {
  //     filterInfo = `Report for Date: ${displayDate(selectedDate)}`;
  //     fileName += `_${selectedDate}`;
  //   } else if (searchTerm) {
  //     // ✅ fixed here
  //     const found = filteredOrders[0];
  //     if (found) {
  //       if (found.invoice_no.includes(searchTerm)) {
  //         filterInfo = `Report for Invoice No: ${found.invoice_no}`;
  //         fileName += `_invoice_${found.invoice_no.replace(/\//g, "-")}`;
  //       } else if (found.customer_mobile.includes(searchTerm)) {
  //         filterInfo = `Report for Mobile: ${found.customer_mobile}`;
  //         fileName += `_mobile_${found.customer_mobile}`;
  //       }
  //     }
  //   } else {
  //     filterInfo = "Report for All Records";
  //     fileName += `_all`;
  //   }

  //   doc.setFontSize(12);
  //   doc.text(filterInfo, 14, 25);

  //   const tableData = [];
  //   let serialNo = 1;

  //   filteredOrders.forEach((order) => {
  //     order.cart.forEach((item, itemIndex) => {
  //       tableData.push([
  //         itemIndex === 0 ? serialNo++ : "", // S.NO
  //         itemIndex === 0 ? order.invoice_no : "",
  //         itemIndex === 0 ? order.customer_name : "",
  //         itemIndex === 0 ? order.customer_mobile : "",
  //         itemIndex === 0 ? displayDate(order.order_date) : "",
  //         itemIndex === 0 ? order.billername : "",
  //         item.product_name,
  //         item.quantity,
  //         parseFloat(item.price).toFixed(2),
  //         (item.quantity * item.price).toFixed(2),
  //         itemIndex === 0 ? parseFloat(order.paid_amount).toFixed(2) : "",
  //       ]);
  //     });
  //   });

  //   autoTable(doc, {
  //     head: [
  //       [
  //         "S.NO",
  //         "Invoice",
  //         "Customer",
  //         "Mobile",
  //         "Date",
  //         "Biller",
  //         "Product",
  //         "Qty",
  //         "Price",
  //         "Subtotal",
  //         "Order Total",
  //       ],
  //     ],
  //     body: tableData,
  //     startY: 35,
  //     styles: { lineWidth: 0.2, lineColor: [0, 0, 0], textColor: [0, 0, 0] },
  //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
  //     theme: "grid",
  //   });

  //   const totalAmount = calculateTotal().toFixed(2);
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const totalText = `Total : Rs. ${totalAmount}`;
  //   const textWidth = doc.getTextWidth(totalText);
  //   const x = pageWidth - textWidth - 14;

  //   doc.setFontSize(12);
  //   doc.text(totalText, x, doc.lastAutoTable.finalY + 10);

  //   doc.save(`${fileName}.pdf`);
  // };
  const downloadPDF = () => {
    if (filteredOrders.length === 0) {
      Swal.fire("No Data", "No orders to download", "info");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Retail Orders Report", 14, 15);

    // 🔹 Helper function for DD-MM-YYYY format
    const formatDateDMY = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Determine report filter info & dynamic filename
    let filterInfo = "";
    let fileName = "retail_orders";

    const todayStr = formatDateDMY(new Date());

    if (filter === "today") {
      filterInfo = `Report for Today (${todayStr})`;
      fileName += `_${todayStr}`;
    } else if (filter === "yesterday") {
      const y = new Date();
      y.setDate(y.getDate() - 1);
      filterInfo = `Report for Yesterday (${formatDateDMY(y)})`;
      fileName += `_${formatDateDMY(y)}`;
    } else if (filter === "lastweek") {
      filterInfo = "Report for Last Week";
      fileName += `_lastweek`;
    } else if (filter === "lastmonth") {
      filterInfo = "Report for Last Month";
      fileName += `_lastmonth`;
    } else if (selectedDate) {
      filterInfo = `Report for Date: ${formatDateDMY(selectedDate)}`;
      fileName += `_${formatDateDMY(selectedDate)}`;
    } else if (searchTerm) {
      const found = filteredOrders[0];
      if (found) {
        if (found.invoice_no.includes(searchTerm)) {
          filterInfo = `Report for Invoice No: ${found.invoice_no}`;
          fileName += `_invoice_${found.invoice_no.replace(/\//g, "-")}`;
        } else if (found.customer_mobile.includes(searchTerm)) {
          filterInfo = `Report for Mobile: ${found.customer_mobile}`;
          fileName += `_mobile_${found.customer_mobile}`;
        }
      }
    } else {
      filterInfo = "Report for All Records";
      fileName += `_all`;
    }

    doc.setFontSize(12);
    doc.text(filterInfo, 14, 25);

    const tableData = [];
    let serialNo = 1;

    filteredOrders.forEach((order) => {
      order.cart.forEach((item, itemIndex) => {
        tableData.push([
          itemIndex === 0 ? serialNo++ : "", // S.NO
          itemIndex === 0 ? order.invoice_no : "",
          itemIndex === 0 ? order.customer_name : "",
          itemIndex === 0 ? order.customer_mobile : "",
          itemIndex === 0 ? formatDateDMY(order.order_date) : "", // 🔹 Table date in DD-MM-YYYY
          itemIndex === 0 ? order.billername : "",
          item.product_name,
          item.quantity,
          parseFloat(item.retail_price).toFixed(2),
          (item.quantity * item.retail_price).toFixed(2),
          itemIndex === 0 ? parseFloat(order.paid_amount).toFixed(2) : "",
        ]);
      });
    });

    autoTable(doc, {
      head: [
        [
          "S.NO",
          "Invoice",
          "Customer",
          "Mobile",
          "Date",
          "Biller",
          "Product",
          "Qty",
          "Price",
          "Subtotal",
          "Order Total",
        ],
      ],
      body: tableData,
      startY: 35,
      styles: { lineWidth: 0.2, lineColor: [0, 0, 0], textColor: [0, 0, 0] },
      headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      theme: "grid",
    });

    const totalAmount = calculateTotal().toFixed(2);
    const pageWidth = doc.internal.pageSize.getWidth();
    const totalText = `Total : Rs. ${totalAmount}`;
    const textWidth = doc.getTextWidth(totalText);
    const x = pageWidth - textWidth - 14;

    doc.setFontSize(12);
    doc.text(totalText, x, doc.lastAutoTable.finalY + 10);

    // 🔹 Save file with DD-MM-YYYY format
    doc.save(`${fileName}.pdf`);
  };

  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);

  return (
    <div className="container mt-4">
      {/* Filters */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="form-select form-select-sm"
          style={{ maxWidth: "150px" }}
        >
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="lastweek">Last Week</option>
          <option value="lastmonth">Last Month</option>
        </select>

        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="form-control form-control-sm"
          style={{ maxWidth: "180px" }}
        />

        <input
          type="text"
          placeholder="Search Invoice or Mobile"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control form-control-sm"
          style={{ maxWidth: "220px" }}
        />

        <button className="btn btn-sm btn-primary" onClick={downloadPDF}>
          Download PDF
        </button>
      </div>

      {/* Total */}
      <h6 className="text-end">
        Total: <b>₹{calculateTotal().toFixed(2)}</b>
      </h6>

      {/* Table */}
      <div
        className="table-responsive custom-scrollbar"
        style={{ maxHeight: "70vh" }}
      >
        <table className="table table-bordered table-sm">
          <thead className="table-dark sticky-top">
            <tr>
              <th>S.NO</th>
              <th>Invoice no</th>
              <th>Customer Name</th>
              <th>Biller Name</th>
              <th>Mobile</th>
              <th>Date</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Subtotal</th>

              <th>Total</th>
              <th>Paid Amount</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.length > 0 ? (
              currentOrders.map((order, orderIndex) =>
                order.cart.map((item, itemIndex) => (
                  <tr key={`${orderIndex}-${itemIndex}`}>
                    {itemIndex === 0 && (
                      <>
                        <td rowSpan={order.cart.length}>
                          {indexOfFirst + orderIndex + 1}
                        </td>
                        <td rowSpan={order.cart.length}>{order.invoice_no}</td>
                        <td rowSpan={order.cart.length}>
                          {order.customer_name}
                        </td>
                        <td rowSpan={order.cart.length}>{order.billername}</td>
                        <td rowSpan={order.cart.length}>
                          {order.customer_mobile}
                        </td>
                        <td rowSpan={order.cart.length}>
                          {displayDate(order.order_date)}
                        </td>
                      </>
                    )}
                    <td>{item.product_name}</td>
                    <td>{item.quantity}</td>
                    <td>₹{parseFloat(item.price).toFixed(2)}</td>

                    {/* Subtotal - show once */}
                    {itemIndex === 0 ? (
                      <td rowSpan={order.cart.length}>
                        ₹{parseFloat(order.subtotal).toFixed(2)}
                      </td>
                    ) : null}

                    {/* Total - show once */}
                    {itemIndex === 0 ? (
                      <td rowSpan={order.cart.length}>
                        ₹{parseFloat(order.total).toFixed(2)}
                      </td>
                    ) : null}

                    {/* Paid Amount - show once */}
                    {itemIndex === 0 ? (
                      <td rowSpan={order.cart.length}>
                        ₹{parseFloat(order.paid_amount).toFixed(2)}
                      </td>
                    ) : null}
                  </tr>
                ))
              )
            ) : (
              <tr>
                <td colSpan="13" className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-sm btn-secondary mx-1"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>
          <span className="align-self-center small">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-sm btn-secondary mx-1"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Scrollbar styling */}
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.2);
            border-radius: 4px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: transparent;
          }
        `}
      </style>
    </div>
  );
}
